import {useState, useCallback} from "react";
import styles from "./index.less";
import {Input, Flex, Button, message, Modal} from "antd";
import WangEditView from "../../../components/wangEditView/WangEditView";
import HttpTool from "../../../tool/HttpTool";
import APILXD from '../../../http/APILXD.js';

export default function ProtocolEdit(props) {
  const defaultData = props.post.data;

  console.log("defaultData",defaultData)

  const [title, setTitle] = useState(defaultData?.name);

  const editItem = useCallback((content)=>{
    if(!title){
      message.warning("请填写协议名称")
      return;
    }

    let params = {
      name: title,
      desc: content
    }

    if(defaultData){
      params._id = defaultData._id;
    }else{
      params.groupId = props.post?.groupId
    }

    HttpTool.post(
      defaultData ? APILXD.editAgreement : APILXD.createAgreement,
      () => {
        message.success('操作成功');
        // props.openTab(props.post.parent);
        props.openTab({
          path: 'ProtocolDirectory',
          title: '协议目录',
          post: {
            ...props.post.parent?.post,
            defaultGroupId: props.post?.groupId
          }
        });
        props.closeTab();
      },
      (code, msg) => {
        Modal.warn({
          title: '提示',
          content: msg,
        });
      },
      params,
    );
  },[title])

  return <div
    className={styles.editPage}
  >
    <div className={styles.headBox}>
      <Input
        addonBefore={"协议名称"}
        value={title}
        placeholder="请填写协议名称"
        onChange={(event) => {
          let v = event.target.value;
          setTitle(v);
        }}
        maxLength={50}
      />
      <Flex gap={10}>
        {/*<Button*/}
        {/*  type={"primary"}*/}
        {/*  onClick={() => {*/}
        {/*    editItem()*/}
        {/*  }}*/}
        {/*>*/}
        {/*  {defaultData?"保存":"新增"}*/}
        {/*</Button>*/}
        {/*<Button*/}
        {/*  danger={true}*/}
        {/*  ghost={true}*/}
        {/*  onClick={(event) => {*/}
        {/*    props.closeTab()*/}
        {/*  }}*/}
        {/*>*/}
        {/*  取消*/}
        {/*</Button>*/}
      </Flex>
    </div>
    <div className={styles.bodyBox}>
      <WangEditView
        content={defaultData?.desc || ''}
        onSubmit={(content)=>{
          editItem(content)
        }}
        onCancel={()=>{
          props.openTab({
            path: 'ProtocolDirectory',
            title: '协议目录',
            post: {
              ...props.post.parent?.post,
              defaultGroupId: props.post?.groupId
            }
          });
          props.closeTab();
        }}
      />
    </div>
  </div>
}